import React from 'react'
import AssignationDetail from '../../components/AssignationDetail'

export default () => <AssignationDetail disabled={true}/>
